import FindLangKey from 'Global/Functions/FindLangKey/FindLangKey';
import React from 'react';
import PatientInfoStack from 'Routes/Protected/CurrentPatients/Components/EachPatient/component/PatientInfoStack';

const PatientImageTrigger = ({
  setOpenMedicalImageDialog,
}) => {
  const imgHeader = 'data:image/svg+xml;base64,';
  const fileReport_summurary = FindLangKey(
    'main-menu-button-pacs-images'
  );
  const cachedIcons = JSON.parse(
    localStorage.getItem('icons')
  );
  const fileReport_summurary_image =
    imgHeader +
    cachedIcons?.GeneralIcon['FileRegistration.svg'];

  // console.log('cachedIconscachedIcons ---->', cachedIcons);

  return (
    <React.Fragment>
      <React.Fragment>
        <div
          style={{
            fontWeight: 'bold',
            cursor: 'pointer',
            alignSelf: 'flex-end',
          }}
          onClick={() => {
            setOpenMedicalImageDialog((prev) => !prev);
          }}
        >
          <PatientInfoStack
            ImageSource={fileReport_summurary_image}
            paragraph={fileReport_summurary}
          />
        </div>
      </React.Fragment>
    </React.Fragment>
  );
};

export default PatientImageTrigger;
